import React from "react"
import { useTranslation } from "react-i18next"

import { ConfirmationOverlay } from "shared/ui/confirmation-overlay/ConfirmationOverlay"

interface DeleteProjectOverlayViewProps {
  onDelete: () => void
  onClose: () => void
}

export const DeleteProjectOverlayView = React.memo(
  ({ onDelete, onClose }: DeleteProjectOverlayViewProps) => {
    const { t } = useTranslation()
    return (
      <ConfirmationOverlay.Root id="delete-project-overlay" isDanger>
        <ConfirmationOverlay.Header>
          <ConfirmationOverlay.Title>
            {t("Project.Actions.Delete")}
          </ConfirmationOverlay.Title>
        </ConfirmationOverlay.Header>
        <ConfirmationOverlay.Message>
          {t("Project.DeleteConfirmation")}
        </ConfirmationOverlay.Message>
        <ConfirmationOverlay.Actions>
          <ConfirmationOverlay.Cancel onClick={onClose} />
          <ConfirmationOverlay.Submit onClick={onDelete}>
            {t("General.Delete")}
          </ConfirmationOverlay.Submit>
        </ConfirmationOverlay.Actions>
      </ConfirmationOverlay.Root>
    )
  }
)
